export default __webpack_public_path__ + "img/d8eb559dfb462e5813cc02b4a9882429.svg";